import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { AcRoutingService } from '@core/services/routing/ac-routing.service';
import { catchError } from 'rxjs/operators';
import { EMPTY } from 'rxjs';
import { Store } from '@ngrx/store';
import { StoreState } from '@store/store.state';
import { userActions } from '@store/actions/user.actions';

export const unauthorizedInterceptor: HttpInterceptorFn = (req, next) => {
  const routingService = inject(AcRoutingService);
  const store = inject(Store<StoreState>);
  return next(req).pipe(
    catchError((err: HttpErrorResponse) => {
      if (err.status === 401) {
        routingService.goToUnauthorized();
        store.dispatch(userActions.markWebAsReady());
        return EMPTY;
      }
      throw err;
    })
  );
};
